import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      if (typeof (Storage) !== "undefined") {

        let url = window.location.href;
        let domain = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/img)

        let value = sessionStorage.getItem(`cart-preview-cache-${domain}`);
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          if (value !== null) {
            let ObjectValue = JSON.parse(value);
            let htmlItens = ObjectValue.html_itens
            let itensCartPreview = document.querySelector('.items_cart_preview');
            itensCartPreview.innerHTML = htmlItens
          } else {
            console.log("Não há valor armazenado para a chave fornecida.");
          }
        }

      } else {
        console.log("Desculpe, seu navegador não suporta sessionStorage.");
      }
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  function loadSvg() {
     const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function(svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, {passive: true});

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
    
        const mute = el.find('.mute');
        const video = el.find('video');
    
        if (mute.length && video.length) {
          mute.click((e) => {
            e.preventDefault(); // impede que o clique dispare o link
            e.stopPropagation(); // opcional: impede que o evento suba na árvore

            const videoEl = video.get(0); // ou video[0]
            videoEl.muted = !videoEl.muted;
            mute.toggleClass('active');
          });
        }
    
      } else {
        // el.removeClass("visible");
      }
    });
    
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);
});

// Dynamic Page Slick

const historyCarousel = document.querySelector('#mosaic-1');
const momentsCarousel = document.querySelector('#mosaic-2');
const itemsCarousel = document.querySelector('#mosaic-3');
const whosUse = document.querySelector('#mosaic-4');

if(historyCarousel) {
    $('#mosaic-1').slick({
        arrows: false,
        dots: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        delay: 2000,
        speed: 700,

        responsive: [
          {
              breakpoint: 991,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
          }
        ]
    });
}

if (momentsCarousel) {
    $('#mosaic-2').slick({
      arrows: false,
      dots: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      delay: 2000,
      speed: 700,

      responsive: [
        {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
        }
      ]
    });
}

if (itemsCarousel) {
  $('#mosaic-3').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    delay: 2000,
    speed: 700,

    responsive: [
      {
        breakpoint: 991,
        settings: "unslick"
      },
      {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
      }
    ]
  });
}

if (whosUse) {
  $('#mosaic-4').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    delay: 2000,
    speed: 700,

    responsive: [
      {
        breakpoint: 991,
        settings: "unslick"
      },
      {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
      }
    ]
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const sections = ["help", "institutional", "contact-us"];

  sections.forEach(section => {
      const parentDiv = document.querySelector(`.${section}`);
      if (parentDiv) {
          const content = parentDiv.querySelector("div, ul");
          const title = parentDiv.querySelector(".footer-title");
          
          if (content) {
              content.style.height = `${content.scrollHeight}px`;
              content.classList.add("inactive");
          }

          if (title) {
              title.addEventListener("click", function () {
                title.classList.toggle("active");
                  if (content) {
                      content.classList.toggle("inactive");
                  }
              });
          }
      }
  });
});